import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const newTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'New Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in New Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_new_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving New Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in New Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     planned communities and master planned neighborhoods of <strong>New Tampa</strong>. 
     This rapidly developed area features a mix of newer homes with maturing trees 
     and established green belts that require ongoing professional maintenance. 
     As trees mature faster than expected in Florida's climate, overgrowth near 
     homes and HOA common areas becomes a real issue and we handle it right.`,

    `We specialize in <strong>hazardous tree removal and canopy management</strong> 
     trees pressing against rooflines and fences in tight subdivisions, storm split 
     limbs, palms with leaning or root issues, and large scale trimming that keeps 
     your property compliant and safe. We work efficiently in gated communities 
     and planned neighborhoods every day.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>New Tampa</strong> and surrounding 
     <strong>North Hillsborough County</strong> communities keeping your 
     home and neighborhood safe and well maintained year round.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'New Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_NewTampa = () => <LocationPage config={newTampaConfig} />;
export default Services_NewTampa;
